module.exports = __webpack_public_path__ + "static/media/logo_acud.c024c1d7.png";